var React = require('react');

function LandmarkAlt (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M0 496v-32a16 16 0 0 1 16-16h16v-16a16 16 0 0 1 16-16h16V288h64v128h96V288h64v128h96V288h64v128h16a16 16 0 0 1 16 16v16h16a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16H16a16 16 0 0 1-16-16z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M288 16v18.9A191.88 191.88 0 0 1 445.1 192H464a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16H48a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h18.9A191.88 191.88 0 0 1 224 34.9V16a16 16 0 0 1 16-16h32a16 16 0 0 1 16 16z","className":"fa-primary","key":2})]);
}

LandmarkAlt.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = LandmarkAlt;

LandmarkAlt.default = LandmarkAlt;
